import { memo, useEffect, useState } from 'react'

import { IAccessibility } from 'clickNgo/models/widget'
import { initFormData, resetAllModifiedDataByKey } from 'cng-common/features/form'
import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'
import { ModalDialog } from 'core-components/library/modalDialog'

import { contactEditorDefaultSetting, ContactEditorFormKeys } from './configs'
import { ContactEditorContent } from './ContactEditorContent'
import { TContactSettingProps, TExistedContactProps, TNewContactProps } from './models'

import styles from './ContactEditor.module.scss'

type TProps = (TNewContactProps | TExistedContactProps) & TContactSettingProps & IAccessibility

export const ContactEditor = memo<TProps>((props) => {
  const dispatch = useAppDispatch()
  const [isInitiated, setIsInitiated] = useState(false)
  const isFormReady: boolean = props.contact && props.isVisible

  useEffect(() => {
    if (isFormReady && !isInitiated) {
      dispatch(
        initFormData({
          formKey: ContactEditorFormKeys.settings,
          formData: {
            ...contactEditorDefaultSetting,
            isReadOnly: props.isReadOnly,
          },
        })
      )

      setIsInitiated(true)
    }
  }, [dispatch, isFormReady, isInitiated, props.isReadOnly])

  useEffect(() => {
    return () => {
      Object.values(ContactEditorFormKeys).forEach((key) => {
        dispatch(resetAllModifiedDataByKey(key))
      })

      setIsInitiated(false)
    }
  }, [dispatch])

  if (isFormReady && isInitiated) {
    return (
      <ModalDialog
        onClose={props.onClose}
        show={props.isVisible}
        classes={styles}
        //@ts-ignore
        content={ContactEditorContent}
        contentProps={props}
        size={props.size}
        closeOnOutsideClick={false}
      />
    )
  }

  return null
})

ContactEditor.displayName = 'ContactEditor'
